import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "betaFolder"
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("Beta 驗收資料夾")]), _c('div', {
    staticClass: "bf_toolbar"
  }, [_c('label', {
    staticClass: "bf_label"
  }, [_vm._v("資料夾")]), _c('b-form-select', {
    staticClass: "bf_root",
    attrs: {
      "options": _vm.roots,
      "size": "sm",
      "disabled": !_vm.roots.length
    },
    model: {
      value: _vm.root,
      callback: function callback($$v) {
        _vm.root = $$v;
      },
      expression: "root"
    }
  }), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" 重新整理 ")]), _c('span', {
    staticClass: "bf_stamp"
  }, [_vm._v("每天 02:30 夜間分析跑完後更新；週四的資料日（週五早上）會打週包。")])], 1), _vm.error ? _c('b-alert', {
    staticClass: "mx-3",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.notice ? _c('b-alert', {
    staticClass: "mx-3",
    attrs: {
      "show": "",
      "variant": "success",
      "dismissible": ""
    },
    on: {
      "dismissed": function dismissed($event) {
        _vm.notice = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.notice))]) : _vm._e(), _vm.loading && !_vm.files.length ? _c('b-spinner', {
    staticClass: "mx-3 my-4",
    attrs: {
      "variant": "secondary"
    }
  }) : !_vm.roots.length && !_vm.error ? _c('div', {
    staticClass: "bf_empty"
  }, [_vm._v("還沒有資料：夜間分析第一次跑完後才會出現。")]) : _vm._e(), _vm.root ? _c('b-tabs', {
    staticClass: "mx-2",
    attrs: {
      "nav-class": "bf_segment"
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, _vm._l(_vm.FOLDERS, function (f) {
    return _c('b-tab', {
      key: f.key,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('i', {
            class: f.icon
          }), _vm._v(_vm._s(f.key) + " "), _c('span', {
            staticClass: "bf_count"
          }, [_vm._v(_vm._s(_vm.rowsOf(f.key).length))])];
        },
        proxy: true
      }], null, true)
    }, [_c('p', {
      staticClass: "bf_hint"
    }, [_vm._v(_vm._s(f.hint))]), f.upload ? _c('div', {
      staticClass: "bf_upload"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "primary",
        "disabled": _vm.uploading
      },
      on: {
        "click": function click($event) {
          _vm.$refs['file_' + f.key][0].click();
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-upload",
      class: {
        'fa-spin': _vm.uploading
      }
    }), _vm._v(" 上傳 Excel ")]), _c('input', {
      ref: 'file_' + f.key,
      refInFor: true,
      staticClass: "d-none",
      attrs: {
        "type": "file",
        "accept": ".xlsx"
      },
      on: {
        "change": function change($event) {
          return _vm.upload(f.key, $event);
        }
      }
    })], 1) : _vm._e(), f.key === '每日結果' ? _c('b-table', {
      staticClass: "bf_table",
      attrs: {
        "items": _vm.dailyRows,
        "fields": _vm.dailyFields,
        "small": "",
        "hover": "",
        "show-empty": "",
        "empty-text": "還沒有檔案"
      },
      scopedSlots: _vm._u([{
        key: "cell(files)",
        fn: function fn(_ref) {
          var item = _ref.item;
          return _vm._l(item.files, function (x) {
            return _c('b-button', {
              key: x.name,
              staticClass: "bf_link",
              attrs: {
                "size": "sm",
                "variant": "link"
              },
              on: {
                "click": function click($event) {
                  return _vm.download(x.name);
                }
              }
            }, [_vm._v(_vm._s(x.base))]);
          });
        }
      }], null, true)
    }) : _c('b-table', {
      staticClass: "bf_table",
      attrs: {
        "items": _vm.rowsOf(f.key),
        "fields": _vm.fields,
        "small": "",
        "hover": "",
        "show-empty": "",
        "empty-text": "還沒有檔案"
      },
      scopedSlots: _vm._u([{
        key: "cell(base)",
        fn: function fn(_ref2) {
          var item = _ref2.item;
          return [_c('b-button', {
            staticClass: "bf_link",
            attrs: {
              "size": "sm",
              "variant": "link"
            },
            on: {
              "click": function click($event) {
                return _vm.download(item.name);
              }
            }
          }, [_vm._v(_vm._s(item.base))])];
        }
      }], null, true)
    })], 1);
  }), 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };